import React, { useEffect, useState, useRef } from "react"; // [EXPERT_COMMENT]: Añadida importación de useRef - Necesario para referenciar el componente Toast.
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button"; // [EXPERT_COMMENT]: Añadida importación de Button - Necesario para los botones de acción.
import { Toast } from "primereact/toast"; // [EXPERT_COMMENT]: Añadida importación de Toast - Necesario para mostrar notificaciones.
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog"; // [EXPERT_COMMENT]: Añadida importación de ConfirmDialog - Necesario para diálogos de confirmación.
import CrearClientes from "./CrearClientes"; // [EXPERT_COMMENT]: Añadida importación de CrearClientes - Componente modal para crear clientes.
import EditarClientes from "./EditarClientes"; // [EXPERT_COMMENT]: Añadida importación de EditarClientes - Componente modal para editar clientes.
import "../styles/clientes.css";
import { fetchWithAuth, API_URL } from "../Componentes/fetchWithAuth"; // [EXPERT_COMMENT]: Importación de fetchWithAuth y API_URL - Se importan para realizar solicitudes autenticadas y usar la URL de API consistente.

// const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api'; // [EXPERT_COMMENT]: Eliminación de definición local - Se elimina la definición local de API_URL para usar la importada de fetchWithAuth.

const ListaClientes = ({ language }) => {
  const [clientes, setClientes] = useState([]);
  const [filteredClientes, setFilteredClientes] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [selectedCliente, setSelectedCliente] = useState(null); // [EXPERT_COMMENT]: Nuevo estado para cliente seleccionado - Almacena el cliente seleccionado en la tabla.
  const [isCreateModalOpen, setCreateModalOpen] = useState(false); // [EXPERT_COMMENT]: Nuevo estado para modal de creación - Controla la visibilidad del modal de creación.
  const [isEditModalOpen, setEditModalOpen] = useState(false); // [EXPERT_COMMENT]: Nuevo estado para modal de edición - Controla la visibilidad del modal de edición.
  const toastCenter = useRef(null); // [EXPERT_COMMENT]: Nueva referencia para Toast - Permite mostrar notificaciones.

  const getTranslations = (lang) => {
    const translations = {
      es: {
        title: "Lista de Clientes",
        searchPlaceholder: "Buscar...",
        createButton: "Nuevo", // [EXPERT_COMMENT]: Renombrado: "Agregar Nuevo Cliente" -> "Nuevo"
        editButton: "Editar", // [EXPERT_COMMENT]: Renombrado: "Editar Cliente" -> "Editar"
        deleteButton: "Anular", // [EXPERT_COMMENT]: Renombrado: "Eliminar Cliente" -> "Anular" - Refleja mejor la eliminación lógica.
        text_Confirmacion: "Confirmación", // [EXPERT_COMMENT]: Nueva traducción para confirmación - Título para diálogos de confirmación.
        yesbutton: "Sí", // [EXPERT_COMMENT]: Nueva traducción para botón Sí - Texto para el botón de aceptar en diálogos.
        nobutton: "No", // [EXPERT_COMMENT]: Nueva traducción para botón No - Texto para el botón de cancelar en diálogos.
        accioncancelada: "Acción Cancelada", // [EXPERT_COMMENT]: Nueva traducción para acción cancelada - Mensaje de cancelación.
        cliente_eliminado: "Cliente Eliminado", // [EXPERT_COMMENT]: Nueva traducción para cliente eliminado - Mensaje de éxito al eliminar.
        error_eliminar_cliente: "Error al eliminar cliente", // [EXPERT_COMMENT]: Nueva traducción para error al eliminar - Mensaje de error al eliminar.
        actualizacion_exitosa: "Actualización Exitosa", // [EXPERT_COMMENT]: Nueva traducción para actualización exitosa - Mensaje de éxito al actualizar.
        erroralactualizar: "Error al Actualizar", // [EXPERT_COMMENT]: Nueva traducción para error al actualizar - Mensaje de error al actualizar.
        dialog_mje_elim_cliente:
          "¿Está seguro de que desea eliminar este cliente?", // [EXPERT_COMMENT]: Nueva traducción para mensaje de eliminación - Mensaje de confirmación para eliminar cliente.
        errorEditCliente: "Debe seleccionar un cliente para editar.", // [EXPERT_COMMENT]: Nueva traducción para error de edición - Mensaje de error si no hay cliente seleccionado para editar.
        cliente_creado_exito: "Cliente creado con éxito", // [EXPERT_COMMENT]: Nueva traducción para mensaje de éxito al crear cliente - Mensaje de confirmación de creación.
        columns: [
          { field: "iCodigo", header: "Código" },
          { field: "sNombreCliente", header: "Nombre" },
          { field: "sTelefono", header: "Teléfono 1" },
          // { field: "sTelefono2", header: "Teléfono 2" }, // [EXPERT_COMMENT]: Comentado: Columna sTelefono2 - Se comenta la columna para el segundo teléfono para deshabilitarla temporalmente.
          // { field: "sEmail", header: "Correo Electrónico" }, // [EXPERT_COMMENT]: Comentado: Columna sEmail - Se comenta la columna para el correo electrónico para deshabilitarla temporalmente.
          { field: "sMarca", header: "Marca" },
          { field: "sNombreCiudad", header: "Ciudad" },
          {
            field: "dFechaCreacion",
            header: "Fecha Creación",
            body: (row) => new Date(row.dFechaCreacion).toLocaleDateString(),
          },
        ],
      },
      en: {
        title: "Clients List",
        searchPlaceholder: "Search...",
        createButton: "Add New Client", // [EXPERT_COMMENT]: Nueva traducción para botón de crear (EN) - Texto para el botón de añadir cliente.
        editButton: "Edit Client", // [EXPERT_COMMENT]: Nueva traducción para botón de editar (EN) - Texto para el botón de editar cliente.
        deleteButton: "Delete Client", // [EXPERT_COMMENT]: Nueva traducción para botón de eliminar (EN) - Texto para el botón de eliminar cliente.
        text_Confirmacion: "Confirmation", // [EXPERT_COMMENT]: Nueva traducción para confirmación (EN) - Título para diálogos de confirmación.
        yesbutton: "Yes", // [EXPERT_COMMENT]: Nueva traducción para botón Sí (EN) - Texto para el botón de aceptar en diálogos.
        nobutton: "No", // [EXPERT_COMMENT]: Nueva traducción para botón No (EN) - Texto para el botón de cancelar en diálogos.
        accioncancelada: "Action Cancelled", // [EXPERT_COMMENT]: Nueva traducción para acción cancelada (EN) - Mensaje de cancelación.
        cliente_eliminado: "Client Deleted", // [EXPERT_COMMENT]: Nueva traducción para cliente eliminado (EN) - Mensaje de éxito al eliminar.
        error_eliminar_cliente: "Error deleting client", // [EXPERT_COMMENT]: Nueva traducción para error al eliminar (EN) - Mensaje de error al eliminar.
        actualizacion_exitosa: "Update Successful", // [EXPERT_COMMENT]: Nueva traducción para actualización exitosa (EN) - Mensaje de éxito al actualizar.
        erroralactualizar: "Error Updating", // [EXPERT_COMMENT]: Nueva traducción para error al actualizar (EN) - Mensaje de error al actualizar.
        dialog_mje_elim_cliente: "Are you sure you want to delete this client?", // [EXPERT_COMMENT]: Nueva traducción para mensaje de eliminación (EN) - Mensaje de confirmación para eliminar cliente.
        errorEditCliente: "You must select a client to edit.", // [EXPERT_COMMENT]: Nueva traducción para error de edición (EN) - Mensaje de error si no hay cliente seleccionado para editar.
        cliente_creado_exito: "Client created successfully", // [EXPERT_COMMENT]: Nueva traducción para mensaje de éxito al crear cliente (EN) - Mensaje de confirmación de creación.
        columns: [
          { field: "iCodigo", header: "Code" },
          { field: "sNombreCliente", header: "Name" },
          { field: "sTelefono", header: "Phone 1" },
          // { field: "sTelefono2", header: "Phone 2" }, // [EXPERT_COMMENT]: Comentado: Columna sTelefono2 (EN) - Se comenta la columna para el segundo teléfono para deshabilitarla temporalmente.
          // { field: "sEmail", header: "Email" }, // [EXPERT_COMMENT]: Comentado: Columna sEmail (EN) - Se comenta la columna para el correo electrónico para deshabilitarla temporalmente.
          { field: "sMarca", header: "Brand" },
          { field: "sNombreCiudad", header: "City" },
          {
            field: "dFechaCreacion",
            header: "Creation Date",
            body: (row) => new Date(row.dFechaCreacion).toLocaleDateString(),
          },
        ],
      },
      zh: {
        title: "客户列表",
        searchPlaceholder: "搜索...",
        createButton: "添加新客户", // [EXPERT_COMMENT]: Nueva traducción para botón de crear (ZH) - Texto para el botón de añadir cliente.
        editButton: "编辑客户", // [EXPERT_COMMENT]: Nueva traducción para botón de editar (ZH) - Texto para el botón de editar cliente.
        deleteButton: "删除客户", // [EXPERT_COMMENT]: Nueva traducción para botón de eliminar (ZH) - Texto para el botón de eliminar cliente.
        text_Confirmacion: "确认", // [EXPERT_COMMENT]: Nueva traducción para confirmación (ZH) - Título para diálogos de confirmación.
        yesbutton: "是", // [EXPERT_COMMENT]: Nueva traducción para botón Sí (ZH) - Texto para el botón de aceptar en diálogos.
        nobutton: "否", // [EXPERT_COMMENT]: Nueva traducción para botón No (ZH) - Texto para el botón de cancelar en diálogos.
        accioncancelada: "操作已取消", // [EXPERT_COMMENT]: Nueva traducción para acción cancelada (ZH) - Mensaje de cancelación.
        cliente_eliminado: "客户已删除", // [EXPERT_COMMENT]: Nueva traducción para cliente eliminado (ZH) - Mensaje de éxito al eliminar.
        error_eliminar_cliente: "删除客户时出错", // [EXPERT_COMMENT]: Nueva traducción para error al eliminar (ZH) - Mensaje de error al eliminar.
        actualizacion_exitosa: "更新成功", // [EXPERT_COMMENT]: Nueva traducción para actualización exitosa (ZH) - Mensaje de éxito al actualizar.
        erroralactualizar: "更新错误", // [EXPERT_COMMENT]: Nueva traducción para error al actualizar (ZH) - Mensaje de error al actualizar.
        dialog_mje_elim_cliente: "您确定要删除此客户吗？", // [EXPERT_COMMENT]: Nueva traducción para mensaje de eliminación (ZH) - Mensaje de confirmación para eliminar cliente.
        errorEditCliente: "您必须选择一个客户进行编辑。", // [EXPERT_COMMENT]: Nueva traducción para error de edición (ZH) - Mensaje de error si no hay cliente seleccionado para editar.
        cliente_creado_exito: "客户创建成功", // [EXPERT_COMMENT]: Nueva traducción para mensaje de éxito al crear cliente (ZH) - Mensaje de confirmación de creación.
        columns: [
          { field: "iCodigo", header: "编号" },
          { field: "sNombreCliente", header: "名称" },
          { field: "sTelefono", header: "电话 1" },
          // { field: "sTelefono2", header: "电话 2" }, // [EXPERT_COMMENT]: Comentado: Columna sTelefono2 (ZH) - Se comenta la columna para el segundo teléfono para deshabilitarla temporalmente.
          // { field: "sEmail", header: "电子邮件" }, // [EXPERT_COMMENT]: Comentado: Columna sEmail (ZH) - Se comenta la columna para el correo electrónico para deshabilitarla temporalmente.
          { field: "sMarca", header: "品牌" },
          { field: "sNombreCiudad", header: "市" },
          {
            field: "dFechaCreacion",
            header: "创建日期",
            body: (row) => new Date(row.dFechaCreacion).toLocaleDateString(),
          },
        ],
      },
    };
    return translations[lang] || translations.es;
  };

  const {
    title,
    searchPlaceholder,
    createButton,
    editButton,
    deleteButton,
    text_Confirmacion,
    yesbutton,
    nobutton,
    accioncancelada,
    cliente_eliminado,
    error_eliminar_cliente,
    actualizacion_exitosa,
    erroralactualizar,
    dialog_mje_elim_cliente,
    errorEditCliente,
    cliente_creado_exito,
    columns,
  } = getTranslations(language); // [EXPERT_COMMENT]: Desestructuración de nuevas traducciones - Se añaden las nuevas claves de traducción.

  useEffect(() => {
    const loadClientes = async () => {
      // [EXPERT_COMMENT]: Función asíncrona - Se define una función asíncrona para manejar la carga de datos.
      try {
        const response = await fetchWithAuth(`${API_URL}/api/listaclientes`); // [EXPERT_COMMENT]: Uso de fetchWithAuth - Se utiliza fetchWithAuth para enviar el token de autenticación.
        if (!response.ok) {
          throw new Error("Error en la respuesta del servidor");
        }
        const data = await response.json();
        console.log("[EXPERT_COMMENT]: Datos de clientes cargados:", data); // [EXPERT_COMMENT]: Nuevo log: Datos de clientes cargados - Muestra los datos recibidos del backend para verificar si "Pedro Picapiedra" está presente.
        setClientes(data); // [BUG_FIX]: Sincronizar estado base para búsqueda
        setFilteredClientes(data); // Carga todos los clientes por defecto
      } catch (err) {
        console.error("Error al cargar clientes:", err);
      }
    };

    loadClientes(); // [EXPERT_COMMENT]: Llamada a la función - Se llama a la función para cargar los clientes.
  }, []);

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchText(value);

    const filtered = clientes.filter((cliente) => {
      return (
        (cliente.sNombreCliente &&
          cliente.sNombreCliente.toLowerCase().includes(value)) ||
        (cliente.sTelefono &&
          cliente.sTelefono.toLowerCase().includes(value)) ||
        // (cliente.sTelefono2 && cliente.sTelefono2.toLowerCase().includes(value)) || // [EXPERT_COMMENT]: Comentado: Campo de búsqueda sTelefono2 - Se comenta la inclusión del segundo teléfono en los criterios de búsqueda.
        // (cliente.sEmail && cliente.sEmail.toLowerCase().includes(value)) || // [EXPERT_COMMENT]: Comentado: Campo de búsqueda sEmail - Se comenta la inclusión del correo electrónico en los criterios de búsqueda.
        (cliente.sNombreCiudad &&
          cliente.sNombreCiudad.toLowerCase().includes(value)) ||
        (cliente.sMarca && cliente.sMarca.toLowerCase().includes(value))
      );
    });

    setFilteredClientes(filtered);
  };

  // [EXPERT_COMMENT]: Función para mostrar mensajes Toast - Centraliza la lógica de notificación.
  const showMessage = (severity, summary, detail) => {
    if (toastCenter.current) {
      toastCenter.current.show({ severity, summary, detail, life: 3000 });
    }
  };

  // [EXPERT_COMMENT]: Función para recargar la lista de clientes - Se utiliza después de operaciones de creación, edición o eliminación.
  const cargarClientes = async (success = false) => {
    // [EXPERT_COMMENT]: Modificado: Añadido parámetro 'success' - Permite indicar si la operación fue exitosa.
    try {
      const response = await fetchWithAuth(`${API_URL}/api/listaclientes`);
      if (!response.ok) {
        throw new Error("Error en la respuesta del servidor");
      }
      const data = await response.json();
      setClientes(data);
      setFilteredClientes(data);
      setSelectedCliente(null); // [EXPERT_COMMENT]: Deseleccionar cliente - Se deselecciona cualquier cliente después de recargar la lista.
      if (success) {
        // [EXPERT_COMMENT]: Muestra mensaje de éxito si la operación fue exitosa - Utiliza el nuevo parámetro 'success'.
        showMessage("success", text_Confirmacion, cliente_creado_exito);
      }
    } catch (err) {
      console.error("Error al cargar clientes:", err);
      showMessage("error", "Error", "Error al cargar clientes.");
    }
  };

  // [EXPERT_COMMENT]: Función para manejar la edición de un cliente - Abre el modal de edición si hay un cliente seleccionado.
  const handleEditCliente = () => {
    if (selectedCliente) {
      setEditModalOpen(true);
    } else {
      showMessage("error", "Error", errorEditCliente);
    }
  };

  // [EXPERT_COMMENT]: Función para eliminar un cliente - Realiza la llamada a la API para eliminar un cliente.
  const EliminarCliente = async (idCliente) => {
    try {
      const response = await fetchWithAuth(
        `${API_URL}/api/eliminar-cliente/${idCliente}`,
        {
          method: "PUT", // [EXPERT_COMMENT]: Método PUT para eliminación lógica - Se usa PUT para una eliminación lógica en el backend.
        },
      );
      const data = await response.json();
      if (data.codigo === 0) {
        showMessage("success", text_Confirmacion, cliente_eliminado);
        cargarClientes(); // [EXPERT_COMMENT]: Recargar clientes - Se recarga la lista después de la eliminación exitosa.
      } else {
        showMessage(
          "error",
          error_eliminar_cliente,
          `${error_eliminar_cliente}: ${data.mensaje}`,
        );
      }
    } catch (err) {
      showMessage(
        "error",
        "Error",
        `${error_eliminar_cliente}: ${err.message}`,
      );
    }
  };

  // [EXPERT_COMMENT]: Función para manejar la actualización de un cliente - Se pasa al modal de edición.
  const handleUpdateCliente = async (updatedCliente) => {
    try {
      const response = await fetchWithAuth(
        `${API_URL}/api/clientes/${updatedCliente.iCodigo}`,
        {
          // [EXPERT_COMMENT]: Corrección de ID de cliente - Se utiliza 'iCodigo' en lugar de 'idcliente' para la URL de la solicitud PUT, ya que 'iCodigo' es el identificador correcto del cliente.
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          // [EXPERT_ANALYSIS]: QUÉ: Se envía el objeto 'updatedCliente' directamente. - POR QUÉ: La lógica de formateo y mapeo de campos ahora reside en el componente hijo ('EditarClientes.jsx'). Este componente ya ha preparado el objeto 'updatedCliente' (que ahora es el 'payload') con los nombres de campo correctos que el backend espera. - IMPACTO: Simplifica el componente padre, adhiriéndose al principio de responsabilidad única.
          body: JSON.stringify(updatedCliente),
        },
      );

      if (!response.ok) {
        const errorData = await response.json();
        showMessage("error", erroralactualizar, erroralactualizar);
        throw new Error(errorData.message || erroralactualizar);
      }
      await response.json();
      // [EXPERT_ANALYSIS]: QUÉ: Se elimina la actualización manual del estado local. - POR QUÉ: La línea `setClientes(...)` fue eliminada porque es una fuente potencial de inconsistencia de datos. La función `cargarClientes()`, que se llama a continuación, es la forma más segura y robusta de actualizar la UI, ya que obtiene los datos más recientes directamente desde el servidor después de una actualización exitosa. - IMPACTO: Mejora la fiabilidad y consistencia de los datos mostrados al usuario, evitando discrepancias entre el estado local y la base de datos.
      setEditModalOpen(false);
      cargarClientes(); // [EXPERT_ANALYSIS]: QUÉ: Se mantiene la recarga de datos. - POR QUÉ: Esta es la fuente única de verdad para actualizar la tabla de clientes, asegurando que todos los cambios (incluidos los procesados por el backend, como fechas de actualización) se reflejen correctamente.
      showMessage("success", text_Confirmacion, actualizacion_exitosa);
    } catch (err) {
      showMessage("error", erroralactualizar, err.message);
    }
  };

  return (
    <>
      <Toast ref={toastCenter} position="top-center" baseZIndex={9999} />{" "}
      {/* [EXPERT_COMMENT]: Componente Toast - Para mostrar notificaciones al usuario. */}
      <ConfirmDialog />{" "}
      {/* [EXPERT_COMMENT]: Componente ConfirmDialog - Para diálogos de confirmación. */}
      <div className="contenedorprincipal pagina-clientes">
        {" "}
        {/* [EXPERT_COMMENT]: Uso de nueva clase para control de altura y scroll interno. */}
        <h1 className="titulo">{title}</h1>
        <div className="botonessuperiores">
          {" "}
          {/* [EXPERT_COMMENT]: Contenedor de botones superiores - Agrupa los botones de acción. */}
          {/* Botón para Crear Cliente */}
          <Button
            id="btn-clientes-agregar"
            label={createButton}
            icon="pi pi-plus"
            className="p-button-success"
            onClick={() => setCreateModalOpen(true)}
          />{" "}
          {/* [EXPERT_COMMENT]: Botón "Agregar Nuevo Cliente" - Abre el modal de creación. */}
          {/* Botón para Editar Cliente */}
          <Button
            id="btn-clientes-editar"
            label={editButton}
            icon="pi pi-pencil"
            className="p-button-warning"
            onClick={handleEditCliente}
            disabled={!selectedCliente} // [EXPERT_COMMENT]: Habilitación condicional - Solo habilitado si hay un cliente seleccionado.
          />
          {/* Botón para Eliminar Cliente */}
          <Button
            id="btn-clientes-eliminar"
            label={deleteButton}
            icon="pi pi-trash" // [EXPERT_COMMENT]: Icono de eliminación - Cambiado de pi-delete-left a pi-trash para consistencia.
            className="p-button-danger"
            disabled={!selectedCliente} // [EXPERT_COMMENT]: Habilitación condicional - Solo habilitado si hay un cliente seleccionado.
            onClick={() => {
              confirmDialog({
                message: dialog_mje_elim_cliente,
                header: text_Confirmacion,
                icon: "pi pi-question-circle",
                acceptClassName: "p-button-primary",
                rejectClassName: "p-button-outlined",
                acceptLabel: yesbutton,
                rejectLabel: nobutton,
                accept: () => EliminarCliente(selectedCliente.iCodigo), // [EXPERT_COMMENT]: Corrección de ID de cliente - Se utiliza 'iCodigo' en lugar de 'idcliente' para la eliminación, ya que 'iCodigo' es el identificador correcto del cliente.
                reject: () =>
                  showMessage("info", accioncancelada, accioncancelada),
              });
            }}
          />
        </div>
        {isCreateModalOpen && (
          <CrearClientes
            isOpen={isCreateModalOpen}
            onClose={() => setCreateModalOpen(false)}
            language={language}
            onSave={cargarClientes} // [EXPERT_COMMENT]: Recarga la lista al guardar - Asegura que la lista se actualice después de crear.
            marcasExistentes={clientes.map((c) => c.sMarca ? c.sMarca.toLowerCase().trim() : "")}
          />
        )}
        {isEditModalOpen && (
          <EditarClientes
            isOpen={isEditModalOpen}
            cliente={selectedCliente} // [EXPERT_COMMENT]: Pasa el cliente seleccionado - El modal de edición recibe el cliente a editar.
            language={language}
            onSave={handleUpdateCliente} // [EXPERT_COMMENT]: Pasa la función de actualización - El modal llama a esta función al guardar.
            onClose={() => setEditModalOpen(false)}
          />
        )}
        <div style={{ marginBottom: "2px", textAlign: "center" }}>
          <input
            id="filtro-clientes-search"
            type="text"
            placeholder={searchPlaceholder}
            value={searchText}
            onChange={handleSearch}
            style={{ padding: "5px", width: "200px" }}
          />
        </div>
        <DataTable
          value={filteredClientes}
          paginator
          rows={14}
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
          currentPageReportTemplate="Mostrando {first}-{last} de {totalRecords} registros"
          scrollable
          scrollHeight="flex" // [EXPERT] Se adapta al contenedor flex padre
          responsiveLayout="scroll"
          selectionMode="single"
          selection={selectedCliente}
          onSelectionChange={(e) => setSelectedCliente(e.value)}
          sortMode="multiple"
          stripedRows
          showGridlines
          removableSort
          style={{ flex: 1, minHeight: 0 }}
        >
          {columns.map((col, index) => (
            <Column
              key={index}
              field={col.field}
              header={col.header}
              sortable
              body={(rowData) => {
                const content = col.body
                  ? col.body(rowData)
                  : rowData[col.field];
                return (
                  <span id={`cliente-celda-${rowData.iCodigo}-${col.field}`}>
                    {content}
                  </span>
                );
              }}
            />
          ))}
        </DataTable>
      </div>
    </>
  );
};

export default ListaClientes;
